// bearer-token.ts
import { Capacitor } from '@capacitor/core';
import { SecureStoragePlugin } from 'capacitor-secure-storage-plugin';
import { Device } from '@capacitor/device';
import { getOrFetchBootstrapData } from '@ui/bootstrap-data/bootstrap-data-store';

const TokenKey = 'auth_token';
const DeviceKey = 'deviceName';
const isNative = Capacitor.isNativePlatform();

let currentToken: string | null = null;
let currentDevice: string | undefined = undefined;

function shortTimestamp(): string {
  // 2025-08-05 14:23 → 20250805-1423
  const now   = new Date();
  const pad   = (n: number) => n.toString().padStart(2, '0');
  return (
    now.getFullYear().toString() +
    pad(now.getMonth() + 1) +
    pad(now.getDate()) +
    '-' +
    pad(now.getHours()) +
    pad(now.getMinutes())
  );
}


// TOKEN
export async function initBearerToken() {
  if (!isNative) { currentToken = null; return; } // web: pas de token
  
  await setToken();
  await setDevice();
}

export function getTokenSync() {
  return currentToken;
}

export async function setToken() {
  try { currentToken = (await SecureStoragePlugin.get({key: TokenKey})).value ?? null; }
  catch { currentToken = null; }
}

export async function saveToken(token: string) {
  currentToken = token;
  if (isNative) await SecureStoragePlugin.set({ key: TokenKey, value: token });
}

export async function removeToken() {
  currentToken = null;
  if (isNative) {
    try { await SecureStoragePlugin.remove({ key: TokenKey }); } catch {}
  }
}

export function extractToken(bootstrapData: any): string | undefined {
  try {
    const data = typeof bootstrapData === 'string' ? JSON.parse(bootstrapData) : bootstrapData;
    return data?.user?.access_token;
  } catch { return undefined; }
}



// DEVICE
export function getDeviceSync() {
  return currentDevice;
}

export async function setDevice() {
  if (!isNative) { currentToken = null; return; } // web: pas de token
  try { currentDevice = (await SecureStoragePlugin.get({key: DeviceKey})).value ?? undefined; }
  catch { currentDevice = undefined; }

  if(!currentDevice) {
    const bootstrap = await getOrFetchBootstrapData();
    const site_name = bootstrap?.settings?.branding?.site_name ?? "K'SCOLTA";
    
    try {
      const info = await Device.getInfo();
      const { name, model, platform } = info;

      const friendlyName =
        name && name.trim().length > 2
          ? name.trim()                           // « iPhone de Pierre-Michel »
          : `${model ?? 'Device'} (${platform})`; // « iPhone15,3 (ios) »

      await saveDevice(`App ${site_name} • ${friendlyName} • ${shortTimestamp()}`);
    }
    catch { await saveDevice(`App ${site_name} • ${shortTimestamp()}`); }
  }

  return currentDevice;
}

export async function saveDevice(device: string) {
  currentDevice = device;
  if (isNative) await SecureStoragePlugin.set({ key: DeviceKey, value: device });
}

export async function removeDevice() {
  currentDevice = undefined;
  if (isNative) {
    try { await SecureStoragePlugin.remove({ key: DeviceKey }); } catch {}
  }
}